import wallImage from '@assets/wall.png'
import { useAppStore } from '@store'
import { Partition, Store } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { Euler, Matrix4 } from 'three'
import { OBB } from 'three/examples/jsm/math/OBB'

export function getBasePartition(
  props: Partial<Omit<Partition, 'name' | 'type' | 'image' | 'description'>>,
  store: Store,
): Partition {
  const height = useAppStore.getState().prefs?.ALTOPARED
  const thickness = useAppStore.getState().prefs?.FONDOPARED
  // const increment = store.increment

  // store.addIncrement()
  // Obtener el valor actual de increment y el mayor existente
  const existingIncrements = Array.from(store.items.values())
    .map((item) => parseInt(item.increment, 10))
    .filter(Number.isInteger)
  const maxExistingIncrement = existingIncrements.length > 0 ? Math.max(...existingIncrements) : 0
  const increment = Math.max(store.increment, maxExistingIncrement + 1)

  const texture2 = useAppStore.getState().texture5
  const texture3 = useAppStore.getState().texture6
  const texture4 = useAppStore.getState().texture7
  const texture5 = useAppStore.getState().texture8
  const texture6 = useAppStore.getState().texture9
  const texture7 = useAppStore.getState().texture10

  // if (!texture2 || !texture3) return {}

  const basePartition = {
    name: 'partition',
    type: 'partition',
    selected: false,
    visible: true,
    price: 0,
    height,
    thickness,
    image: wallImage,
    description: 'MSG_306',
    holes: new Set(),
    width: 0,
    altitude: 0,
    rotation: 0,
    x: 200000,
    y: 0,
    z: 200000,
    id: '',
    url: '',
    universal: true,
    catalogID: '',
    idUnidades: -1,
    areas: new Set(),
    end: [1, 1],
    start: [0, 0],
    showAngle: true,
    lowItems: new Set(),
    highItems: new Set(),
    wallVisible: true,
    increment,
    textures: [
      {
        id: texture2?.id,
        searchID: texture2?.searchID,
        zoneName: 'textureA',
        zoneDisplayName: 'MSG_94',
        url: texture2?.url!,
        name: texture2?.name,
        zone: 'textureA',
        groupID: texture2?.groupID,
      },
      {
        id: texture3?.id,
        searchID: texture3?.searchID,
        zoneName: 'textureB',
        zoneDisplayName: 'MSG_95',
        url: texture3?.url!,
        name: texture3?.name,
        zone: 'textureB',
        groupID: texture3?.groupID,
      },
      {
        id: texture4?.id,
        searchID: texture4?.searchID,
        zoneName: 'textureC',
        zoneDisplayName: 'MSG_307',
        url: texture4?.url!,
        name: texture4?.name,
        zone: 'textureC',
        groupID: texture2?.groupID,
      },
      {
        id: texture5?.id,
        searchID: texture5?.searchID,
        zoneName: 'textureD',
        zoneDisplayName: 'MSG_308',
        url: texture5?.url!,
        name: texture5?.name,
        zone: 'textureD',
        groupID: texture5?.groupID,
      },
      {
        id: texture6?.id,
        searchID: texture6?.searchID,
        zoneName: 'textureE',
        zoneDisplayName: 'MSG_309',
        url: texture6?.url!,
        name: texture6?.name,
        zone: 'textureE',
        groupID: texture6?.groupID,
      },
      {
        id: texture7?.id,
        searchID: texture7?.searchID,
        zoneName: 'textureF',
        zoneDisplayName: 'MSG_310',
        url: texture7?.url!,
        name: texture7?.name,
        zone: 'textureF',
        groupID: texture7?.groupID,
      },
    ],
    zones: {
      textureA: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureA',
        material: { ...texture2 },
        index: 0,
      },
      textureB: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureB',
        material: { ...texture3 },
        index: 1,
      },
      textureC: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureC',
        material: { ...texture4 },
        index: 2,
      },
      textureD: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureD',
        material: { ...texture5 },
        index: 3,
      },
      textureE: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureE',
        material: { ...texture6 },
        index: 4,
      },
      textureF: {
        position: toVector3(),
        scale: toVector3(),
        rotation: new Euler(),
        name: 'textureF',
        material: { ...texture7 },
        index: 5,
      },
    },
    matrix: new Matrix4(),
    snappedWall: '',
  } satisfies Partial<Partition>

  for (const [key, value] of Object.entries(props)) {
    if (!key) continue
    basePartition[key] = value
  }

  // const boundingBox = new OBB(toVector3([props.x, 1, props.z]), toVector3())

  const collisionOBB = new OBB(toVector3([props.x, 1, props.z]), toVector3())

  if (store && props.id) {
    store.sceneBoundingBoxes.set(`COBB_${props.id}`, {
      boundingBox: collisionOBB,
      type: 'partition',
    })
  }
  store.increment = store.increment + 1
  return basePartition as Partition
}
